import { useLocation } from 'react-router-dom';
import { useSidebarVisibility } from '../../contexts/SidebarVisibilityContext';
import AppSidebar from './AppSidebar';
import MobileNavDrawer from './MobileNavDrawer';

const AppNavigation = () => {
  const { sidebarHidden } = useSidebarVisibility();
  const location = useLocation();
  const isOnPricingPage = location.pathname.includes('/pricing');

  if (isOnPricingPage) {
    return null;
  }

  return (
    <>
      {!sidebarHidden && (
        <div className='hidden md:flex flex-shrink-0'>
          <AppSidebar />
        </div>
      )}
      {!sidebarHidden && <MobileNavDrawer />}
    </>
  );
};

export default AppNavigation;
